import React from "react";
import { connect } from "react-redux";

import { TableRow, TableCell } from "@mui/material";
import { TextField, Button } from "@mui/material";

import Prix from 'components/Shared/Prix';
import LoadingButton from 'components/Shared/LoadingButton';

import { postFraisRetour } from 'utils/posters';


const AdministrationFraisRetourRow = ({ code, libelle, montant, postFraisRetour, verrouMontant, codeArticle }) => {

    const [editMode, setEditMode] = React.useState(false);
    const [saving, setSaving] = React.useState(false);


    const [c, setCode] = React.useState(code);
    const [l, setLibelle] = React.useState(libelle);
    const [m, setMontant] = React.useState(montant);
    const [ca, setCodeArticle] = React.useState(codeArticle);


    const cancel = () => {
        setCode(code);
        setLibelle(libelle);
        setMontant(montant);
        setCodeArticle(codeArticle);
        setEditMode(false);
    };

    const valid = async () => {

        setSaving(true);

        const fraisRetour = { code:c, libelle:l, montant:m, codeArticle:ca };

        var result = await postFraisRetour(fraisRetour);

        if (!result) {
            setCode(code);
            setLibelle(libelle);
            setMontant(montant);
            setCodeArticle(codeArticle);
        }
        setEditMode(false);

        setSaving(false);
    };


    if (!editMode) {
        return (
            <TableRow hover onClick={() => {setEditMode(true);}}>
                <TableCell>{c}</TableCell>
                <TableCell>{l}</TableCell>
                <TableCell align='right'>
                    <Prix value={m} />
                </TableCell>
                <TableCell>{ca}</TableCell>
                <TableCell></TableCell>
                <TableCell></TableCell>
            </TableRow>
        );
    }

    return (
        <TableRow hover>
            <TableCell>{code}</TableCell>
            <TableCell>
                <TextField
                    value={l}
                    onChange={e => { setLibelle(e.target.value); }}
                    fullWidth
                />
            </TableCell>
            <TableCell align='right'>
                <Prix
                    value={m}
                    editable={!verrouMontant}
                    onChange={floatValue => { setMontant(floatValue); }}
                    allowNegative={false}
                />
            </TableCell>
            <TableCell>
                <TextField
                    value={ca}
                    onChange={e => { setCodeArticle(e.target.value); }}
                    fullWidth
                />
            </TableCell>
            <TableCell
                style={{ paddingLeft: 0, paddingRight: 0 }}
            >
                <Button
                    onClick={cancel}
                    disabled={saving}
                >
                    Annuler
                </Button>
            </TableCell>
            <TableCell
                style={{ paddingLeft: 8, paddingRight: 0 }}
            >
                <LoadingButton
                    onClick={valid}
                    label="Sauvegarder"
                    pending={saving}
                    color="secondary"
                />
            </TableCell>
        </TableRow>
    );

}
const mapDispatchToProps = {
    postFraisRetour
};

export default connect(null, mapDispatchToProps)(AdministrationFraisRetourRow);